export default [
    {
        path: '/agenda',
        name: 'Agenda',
        component: () => import('@/views/pages/agenda/Agenda.vue'),
        meta: {
            requiresAuth: true,
            page: {
                title: 'Agenda',
            }
        }
    },
]